import { AskEvaQueryResponse, ConversationUserRatingType } from 'api-clients/ai-api-client';

export interface EvaAnswerDto extends AskEvaQueryResponse {
  primaryFieldNamesInData?: string[];
  shouldShowTextResponse?: boolean;
  userRating?: ConversationUserRatingType;
  userRatingComment?: string;
}

export interface EvaQuestionAnswer {
  question: string;
  answer: EvaAnswerDto;
  applicantId?: number;
  policyId?: number;
  isHistoryLoaded?: boolean;
  isNewResponse?: boolean;
  /** When the question was asked. Stamped locally for new prompts, or taken from history (UTC). */
  questionDate?: Date;
  /** UI-only: the HITL option the user picked; once set, the option set is locked. */
  hitlSelectedOption?: string;
}

export interface EvaQuestionAnswerChatThread {
  threadId: string;
  applicantId: number | null;
  questionAndAnswers: EvaQuestionAnswer[];
}

export enum EvaAnswerType {
  Policies = 'policies',
  Applicants = 'applicants',
}
